export default __webpack_public_path__ + "static/media/headArrow.dced70ce.svg";